import { useContext, useState } from 'react'

import { FormControlLabel, Switch, withStyles } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import { FormContext } from 'Components/Hooks/ContextForm'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import { interfaces } from 'service/interfaces'

import AdditionalPhotos from './AdditionalPhotos'
import FilesOption from './Files'
import MainFotograps from './MainPhotos'
import ReviewPhotos from './ReviewPhotos'
import { styles } from './styles'

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 60,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible',
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(34px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#26938a',
        opacity: 1,
        border: 'none',
        '&:after': {
          color: 'white',
          fontSize: '10px',
          left: '8px',
          position: 'absolute',
          top: '5px',
        },
      },
    },
  },
  thumb: {
    width: 22,
    height: 22,
    backgroundColor: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: '#f1f1f1',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
    position: 'relative',
    '&:after': {
      color: '#b7b7b7',
      fontSize: '10px',
      position: 'absolute',
      top: '5px',
      right: '8px',
    },
  },
  checked: {},
}))(Switch)

const TabPanel = (props) => {
  const { children, value, index } = props
  return (
    <div>
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

const MostrarContenidoBox = (props) => {
  const { value, setRenderTable, renderTable } = props
  const { formEdit } = useContext(FormContext)
  const classes = styles()
  const [docuEC, setDocuEC] = useState(formEdit.vehicle.vehiculo_info.docu_para_ec)
  const createDismissableSnackbar = useCustomSnackbar()

  const handleChange = (event) => {
    const newValue = event.target.checked
    setDocuEC(newValue)
    Update(newValue)
  }

  const labelStyles = {
    fontSize: '14px',
    fontWeight: '500',
    color: '#555',
    marginRight: '10px',
  }

  const Update = async (newValue) => {
    const body = {
      docu_para_ec: newValue,
    }
    await interfaces.vehicleInterface
      .changeDocuEc(formEdit.vehicle.id, body)
      .then(() => {
        createDismissableSnackbar('Vehículo editado con éxito!', {
          variant: 'success',
        })
        setRenderTable(!renderTable)
      })
      .catch(() =>
        createDismissableSnackbar('Hubo un error!', {
          variant: 'error',
        })
      )
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
          margin: '2rem      ',
        }}
      >
        <FormControlLabel
          control={<IOSSwitch checked={docuEC} onChange={handleChange} name="docuEC" />}
          label={<span style={labelStyles}>Docu. para E.C.</span>}
          labelPlacement="start"
        />
      </div>

      <div className={classes.style}>
        <TabPanel TabPanel value={value} index={0}>
          <MainFotograps />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <ReviewPhotos />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <AdditionalPhotos />
        </TabPanel>

        <TabPanel value={value} index={3}>
          <FilesOption />
        </TabPanel>
      </div>
    </>
  )
}

export default MostrarContenidoBox
